var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    text: _vm.tooltipContent,
    disable: _vm.tooltipContent === '',
  }),expression:"{\n    text: tooltipContent,\n    disable: tooltipContent === '',\n  }"}],staticClass:"cpt-user-spark-wrapper",on:{"mouseenter":_vm.handleMouseEnter}},[_c('div',{staticClass:"spark-icon"},[_c('ChatImg',{attrs:{"src":_vm.sparkConfig.icon}})],1),(_vm.showCount)?_c('div',{staticClass:"spark-count"},[_vm._v(" 连续聊天 "+_vm._s(_vm.spark.continuous_days)+" 天 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }